import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getFullUnitName } from 'src/app/core/helpers/get-unit-name';
import { EIconPath } from '../../../../shared/enums/icons.enum';
import { TCustomField } from '../../custom-fields.model';
import { TBulkCustomFields, TBulkCustomFieldsExtended } from '../bulk-custom-fields.model';
import { checkBulkFieldTooltip } from '../utils/check-bulk-field-tooltip';

@Component({
  selector: 'pp-bulk-field-numbers',
  templateUrl: './bulk-field-numbers.component.html',
  styleUrls: ['../bulk-custom-fields-modal.component.scss'],
  standalone: false,
})
export class BulkFieldNumbersComponent {
  @Input() ppCustomField: TCustomField;
  @Input() ppCustomFields: TBulkCustomFields<number>;
  @Input() ppFieldId: string;
  @Input() ppCustomFieldsExtended: TBulkCustomFieldsExtended<number>;
  @Input() ppWorkspaceId: string;
  @Input() ppDisabled = false;

  @Output() ppCustomFieldsExtendedChange = new EventEmitter<TBulkCustomFieldsExtended>();
  @Output() ppCustomFieldsChange = new EventEmitter<TBulkCustomFields>();

  EIconPath = EIconPath;
  unitName: string;
  tooltipText: string;
  disabled = false;

  constructor() {}

  ngOnChanges(): void {
    this.disabled = this.ppDisabled || this.ppCustomField.lockedValue;
    this.tooltipText = checkBulkFieldTooltip(this.ppCustomField);

    this.unitName = getFullUnitName(this.ppCustomField.unit);
  }

  updateNumbers(numbers: string, field: TCustomField): void {
    this.ppCustomFields[field.id] = +numbers;

    this.ppCustomFieldsExtended[field.id] = {
      value: this.ppCustomFields[field.id],
      label: field.label,
      type: field.type,
    };

    this.ppCustomFieldsChange.emit(this.ppCustomFields);
    this.ppCustomFieldsExtendedChange.emit(this.ppCustomFieldsExtended);
  }
}
